import type { ReactNode } from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';
import { TableCell, TableRow } from '../../primitives/table';

const emptyTableStateTone = cva('', {
    variants: {
        tone: {
            muted: 'text-muted-foreground [&>p]:text-sm',
            default: 'text-foreground [&>p]:text-base [&>p]:font-medium',
        },
    },
    defaultVariants: { tone: 'muted' },
});

type EmptyTableStateProps = VariantProps<typeof emptyTableStateTone> & {
    colSpan: number;
    message?: string;
    /** Additive: merged onto the cell's default `text-center py-8`, e.g. to fill and center
     *  within a taller row instead of sitting near the top. */
    className?: string;
    /** Rendered under the message, e.g. an action. */
    children?: ReactNode;
};

export function EmptyTableState({
    colSpan,
    message = 'No results found',
    className,
    tone,
    children,
}: EmptyTableStateProps) {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} className={cn('text-center py-8', className)}>
                <div className={emptyTableStateTone({ tone })}>
                    <p>{message}</p>
                </div>
                {children != null && <div className="mt-6">{children}</div>}
            </TableCell>
        </TableRow>
    );
}
